import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "./core/has.js";
import { getInterceptor as t, addQueryParameter as r } from "./core/urlUtils.js";
export { buildDate, commitHash as revision } from "./support/revision.js";
var a = "4.22",
    s = {
  request: function request(e, r) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var a, _yield$import, s, n, o, i, u;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return import("./request.js");

            case 2:
              _yield$import = _context.sent;
              s = _yield$import.default;
              n = e.options;
              o = n.responseType;
              n.signal = null == r ? void 0 : r.signal, n.responseType = "native" === o || "native-request-init" === o ? "native-request-init" : ["blob", "json", "text"].includes(o) && null != (a = t(e.url)) && a.after ? o : "array-buffer";
              _context.next = 9;
              return s(e.url, n);

            case 9:
              i = _context.sent;
              u = {
                data: i.data,
                ssl: i.ssl
              };
              _context.t0 = i.requestOptions.responseType;
              _context.next = _context.t0 === "native-request-init" ? 14 : _context.t0 === "blob" ? 15 : _context.t0 === "json" ? 19 : _context.t0 === "text" ? 21 : 22;
              break;

            case 14:
              return _context.abrupt("return", (delete u.data.signal, u));

            case 15:
              _context.next = 17;
              return u.data.arrayBuffer();

            case 17:
              u.data = _context.sent;
              return _context.abrupt("break", 22);

            case 19:
              u.data = new TextEncoder().encode(JSON.stringify(u.data)).buffer;
              return _context.abrupt("break", 22);

            case 21:
              u.data = new TextEncoder().encode(u.data).buffer;

            case 22:
              return _context.abrupt("return", {
                result: u,
                transferList: [u.data]
              });

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};
var n;

function o(e) {
  n = e;
}

function i(e) {
  var t = n && n.findCredential(e);
  return t && t.token ? r(e, "token", t.token) : e;
}

e("host-webworker") || (e("edge") || e("trident")) && console.warn("Deprecated browser - see http://esriurl.com/oldbrowser");
export { i as addTokenParameter, n as id, o as setId, a as version, s as workerMessages };